module.exports = __webpack_public_path__ + "img/index4.43fff749.png";